module.exports = __webpack_public_path__ + "media/images/calendar/june-af195e378074b007f90eb3857d5c48d4.jpg";